export function replacer(key: any, value: any) {
  // Filtering out properties
  if (value === null) {
    return undefined
  }
  return value
}

export function clean(obj: any, exceptions?: any[]) {
  for (var propName in obj) {
    if (
      (obj[propName] === null ||
        obj[propName] === undefined ||
        obj[propName] === '') &&
      !exceptions?.includes(propName)
    ) {
      delete obj[propName]
    }
  }
}

export function deepClean(obj: any) {
  for (const propName in obj) {
    if (typeof obj[propName] === 'object' && obj[propName] !== null) {
      clean(obj[propName]) // Recursively clean child objects
      if (Object.keys(obj[propName]).length === 0) {
        delete obj[propName] // Remove empty objects
      }
    } else if (
      obj[propName] === null ||
      obj[propName] === undefined ||
      obj[propName] === ''
    ) {
      delete obj[propName]
    }
  }
}
